module.exports = __webpack_public_path__ + "static/assets/b7118727b958b3d2e1949b3b600a17c7.svg";